<template>
  <tbody>
  <tr>
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název kodeku' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Kód kodeku' | translate">
      {{ entity.code }}
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteCodec">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

export default {
  name: "CodecRow",
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  methods: {
    emitDeleteCodec() {
      this.$emit('deleteCodec', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/codecs/CodecRow.vue